// components/common/Journey/journeySafetyNotice.ts

/**
 * Kriticky důležité informace o bezpečném hraní bonusů.
 *
 * Toto NENÍ krok cesty (journey step) — nejde o žádnou akci, kterou uživatel
 * "dokončí", proto se nikam neukládá (žádné ID, žádný zápis na backend).
 * Je to trvalé upozornění, které:
 *   1) je vždy viditelné v kartě Tvoje cesta jako zvýrazněný panel,
 *   2) musí uživatel potvrdit, že přečetl, než smí sekci Začínáme skrýt
 *      (viz SafetyNoticeModal + gate v Journey.tsx).
 */

export interface SafetyNoticeSection {
	heading?: string;
	body: string;
}

export const SAFETY_NOTICE_TITLE = "Jak nepřijít o peníze?";

export const SAFETY_NOTICE_INTRO =
	"Apelujeme na Tebe, abys dával/a pozor. Kasína nejsou hloupá. Bonusy nenabízí z dobroty srdce. Počítají s tím, že neudržíš emoce na uzdě. První dny v DigiBrigi se pojí s poměrně zajímavými výdělky ve velmi krátkém čase a nízkým úsilím. Spousta lidí tak pojímá názor, že hraní v kasínu je způsob, jak zábavně vydělat peníze. To může vést ke vzniku závislosti, což má devastující následky na hráče i jeho blízké.";

export const SAFETY_NOTICE_SECTIONS: SafetyNoticeSection[] = [
	{
		heading: "Hazard je ztrátový",
		body: "Lidé jen za poslední rok prohráli v českých legálních kasínech asi 68 miliard korun. Hazard samotný nikdy není ziskový. V průměru budeš na hazardu i s námi prohrávat. S tím nic neuděláme. Spoléháme na to, že na bonusech získáš více peněz, než kolik jsi prohrál/a na hazardních hrách.",
	},
	{
		heading: "Pokud jsi prohrál/a peníze",
		body: "Pokud při hraní nějakého bonusu prohráváš, dej emoce stranou. Bonus dohraj. Stále máš výhodu na své straně, proto nedává logický smysl přestat. Skončit chce pouze nelogický strach.",
	},
	{
		heading: "Pokud jsi vyhrál/a peníze",
		body: "Pokud při hraní nějakého bonusu vyhráváš a přemýšlíš, zdali přestat a nechat si, co jsi vyhrál/a, tak odpověď zní NE. Bonus dohraj. Stále máš výhodu na své straně, proto nedává logický smysl přestat. Skončit chce pouze nelogický strach.",
	},
	{
		heading: "Čti vše pečlivě",
		body: "Čti pečlivě jednotlivé kroky, co píšeme v návodu, ale i vše, co na Tebe při hraní vyskočí. Často to mohou být důležité informace a je lepší je znát, než je ignorovat.",
	},
	{
		heading: "Nehledej vlastní bonusy",
		body: "Na DigiBrigi najdeš naprostou většinu ziskových bonusů. Pokud tam nějaké nepíšeme, je to z toho důvodu, že buď nejsou ziskové, jsou velice málo ziskové (méně než 20 Kč), nebo je zde neúměrné riziko odměně (např. hraj s návratností 100,3 % velmi volatilní hru). Posledním důvodem může být, že bonus byl nabídnut pouze Tobě. V takovém případě je na Tvém zvážení, jestli ho využiješ. Doporučíme se zeptat AI, zdali má pozitivní návratnost, a důkladně si bonus přečíst. Pokud po Tobě chtějí, abys na automatech prosázel/a do 10násobku hodnoty bonusu, tak by bonus měl být ziskový. Ovšem jelikož my bonus nevidíme, nemůžeme to zhodnotit a neručíme za Tvé rozhodnutí. Pro začátečníky nedoporučujeme.",
	},
	{
		heading: "Nehraj u jiných kasín",
		body: "Pokud najdeš nějaké kasíno v reklamě a nabízí skvělý vstupní bonus a na DigiBrigi ho nemáme, tak je vysoká pravděpodobnost, že toto kasíno nemá licenci od Ministerstva financí České republiky. Pokud budeš hrát u těchto kasín, hrozí Ti, že peníze, které vložíš, už neuvidíš.",
	},
	{
		heading: "Neutrať vše",
		body: "I když peníze nenecháš v kasínu a budeš v zisku, hrozí nový problém. Tím jsi ty sám/sama a touha po lepším životním stylu. Pokud začneš hrát s DigiBrigi a budeš vydělávat třeba 20 tisíc korun měsíčně, a tak začneš utrácet o 20 tisíc měsíčně více, tak je to vlastně k ničemu. Bohatí lidé své peníze neprojedí. Investují, aby v budoucnu peněz měli více a třeba nemuseli pracovat do 65 let. Doporučíme vzdělávat se ve financích. Přečti si něco o „pasivním investování“ a toho se drž. Neskoč na vlnu tradingu, kde většina lidí prodělá. Drž se ověřené strategie a využívej globální ETF, která jsou vhodná i pro nové investory.",
	},
	{
		heading: "Mysli na daně",
		body: "I pokud nechceš nic investovat, tak si určitě část peněz nech na daně. Z těchto výdělků budeš muset danit 15 %, pokud vyděláš za rok více jak 50 000 Kč v některé z kategorií hazardu (slot, živé...). Pokud si vše poctivě píšeš do naší platformy, tak Ti k daňovému přiznání dáme podklady a bude to hračka. Pokud nedejbože hraješ i bez bonusů, jen tak pro zábavu, piš si to někam též. Jinak můžeš mít problémy s daněmi a to je poslední věc, co chceš.",
	},
];

export const SAFETY_NOTICE_TIP =
	"💡 Tip: Nevíš, jak začít investovat? Koukni do naší investiční sekce. Chceš investovat pasivně a dlouhodobě? Můžeš se inspirovat koláčem, kam investují tvůrci DigiBrigi přes brokera Trading 212. Koukni na Algapia koláč.";
